module.exports = __webpack_public_path__ + "static/media/fig_jam.2502684c.png";